import React, { useState } from "react";
import { useIsMobile } from "../../hooks/useIsMobile.ts";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Tabs,
    Tab,
    Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import UsageTable from "./UsageTable.tsx";
import TrainingUsageTable from "./TrainingUsageTable.tsx";
// import TrainingUsageTable from "./TrainingUsageTable.tsx";  // ← lo creeremo dopo

export default function UsageTableDialog({
    open,
    onClose,
    tournamentId
}: {
    open: boolean;
    onClose: () => void;
    tournamentId: number | null;
}) {
    const isMobile = useIsMobile();
    const [tabIndex, setTabIndex] = useState(0);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl" fullScreen={isMobile}>
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: "primary.main"
                }}
            >
                Tabellone Impiego Giocatori
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            {/* ---- TABS ---- */}
            <Tabs
                value={tabIndex}
                onChange={(_, newValue) => setTabIndex(newValue)}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab label="Utilizzo in Partita" />
                <Tab label="Presenze Allenamenti" />
            </Tabs>

            {/* ---- TAB CONTENT ---- */}
            <DialogContent dividers sx={{ padding: 2 }}>
                {tabIndex === 0 && (
                    <Box sx={{ mt: 1 }}>
                        <UsageTable tournamentId={tournamentId} />
                    </Box>
                )}

                {tabIndex === 1 && (
                    <Box sx={{ mt: 1 }}>
                        <TrainingUsageTable tournamentId={tournamentId} />
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}
